
import axios from '@/plugins/axios'

export const fetchCurrency = async (cbk) => {
  const { data } = await axios.get('/api/currency')
  if (cbk && typeof cbk === 'function') cbk(data)
}

